// 用户账号信息
export const LOGIN = 'LOGIN'

export const SET_PHONE = 'SET_PHONE'

export const ENABLE_JSSDK = 'ENABLE_JSSDK'
export const DISABLE_JSSDK = 'DISABLE_JSSDK'

export const SET_ADDRESS = 'SET_ADDRESS'

export const GET_LOCATION = 'GET_LOCATION'

export const SCAN_QRCODE = 'SCAN_QRCODE'

export const SET_AWARDED = 'SET_AWARDED'

export const SET_SHOP_OPENID = 'SET_SHOP_OPENID'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js